import BaseService from './baseService'; 

export class ReadingService extends BaseService {
    constructor(){
        const baseUrl = "/sr";
        super(baseUrl);
    }  
} 